import { memo } from 'react';
import { withTheme } from '@material-ui/core';

const RepeatEveryYear = (props) => {
  const { color = props.theme.iconColor, width = '20' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height="15"
      viewBox="0 0 14 15"
      fill="none">
      <path
        d="M12 7.0026V3.0026C12 2.26927 11.4 1.66927 10.6667 1.66927H10V0.335938H8.66667V1.66927H3.33333V0.335938H2V1.66927H1.33333C0.6 1.66927 0 2.26927 0 3.0026V12.3359C0 13.0693 0.6 13.6693 1.33333 13.6693H6V12.3359H1.33333V5.66927H10.6667V7.0026H12ZM10.6667 4.33594H1.33333V3.0026H10.6667V4.33594ZM8.42667 12.3359C8.71333 13.3026 9.60667 14.0026 10.6667 14.0026C11.9533 14.0026 13 12.9559 13 11.6693C13 10.3826 11.9533 9.33594 10.6667 9.33594C10.0333 9.33594 9.45333 9.58927 9.03333 10.0026H10V11.0026H7.33333V8.33594H8.33333V9.28927C8.93333 8.7026 9.76 8.33594 10.6667 8.33594C12.5067 8.33594 14 9.82927 14 11.6693C14 13.5093 12.5067 15.0026 10.6667 15.0026C9.05333 15.0026 7.70667 13.8559 7.4 12.3359H8.42667Z"
        fill={color}
      />
    </svg>
  );
};

export default withTheme()(memo(RepeatEveryYear));
